// num is in seconds
export function minToHours(num: number): string {
  const hours = num / 60 / 60;
  const rhours = Math.floor(hours);

  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  return rhours === 0 ? `${rminutes}` : `${rhours}h, ${rminutes}`;
}
